import { render, staticRenderFns } from "./i-slide-show.vue?vue&type=template&id=5beee50b&scoped=true&"
import script from "./i-slide-show.vue?vue&type=script&lang=js&"
export * from "./i-slide-show.vue?vue&type=script&lang=js&"
import style0 from "./i-slide-show.vue?vue&type=style&index=0&id=5beee50b&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5beee50b",
  null
  
)

export default component.exports